import React from 'react';
import * as Style from './IconCheckCircle.style';

const IconCheckCircle = ({
  color = '#35CF8B',
  testId = 'icon-check-circle',
  size = '20',
}) => (
  <Style.Wrapper data-testid={testId}>
    <svg xmlns="http:// www.w3.org/2000/svg" width={size} fill="none" height={size} viewBox="0 0 21 20">
      <path d="M6.74984 9.99996L9.24984 12.5L14.2498 7.49996M18.8332 9.99996C18.8332 14.6023 15.1022 18.3333 10.4998 18.3333C5.89746 18.3333 2.1665 14.6023 2.1665 9.99996C2.1665 5.39758 5.89746 1.66663 10.4998 1.66663C15.1022 1.66663 18.8332 5.39758 18.8332 9.99996Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  </Style.Wrapper>
);


export default IconCheckCircle;
